import type { Breakpoint } from '@sds-system/types';

export const breakpoints = [768, 1440] as const;
export const breakpoint: Breakpoint = {
  tablet: breakpoints[0],
  pc: breakpoints[1],
};
